import { render, staticRenderFns } from "./clazzrule-repo.vue?vue&type=template&id=83dcb828&"
import script from "./clazzrule-repo.vue?vue&type=script&lang=js&"
export * from "./clazzrule-repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports